import _find from 'lodash/find';
import _get from 'lodash/get';
import countries from 'constants/countries';

export const normalizeToCountryCode = value => {
  const country = _find(countries, { code: value }) || _find(countries, { name: value });
  return _get(country, 'code', null);
};